module.exports = __webpack_public_path__ + "media/flags/fr-0a4673b0.gif";